import type { MessageKey, Messages } from './messages'

export type TranslationVars = Record<string, string | number>

// Busca el texto y sustituye `{nombre}` por su valor. Una variable sin valor se deja tal cual
// (visible en pruebas, en lugar de desaparecer en silencio).
export const translate = (messages: Messages, key: MessageKey, vars: TranslationVars = {}): string =>
	messages[key].replace(/\{(\w+)\}/g, (match, name: string) => (name in vars ? String(vars[name]) : match))
